import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { LeftChevronIcon, RightChevronIcon } from "wm-graphics";

import "./Slideshow.scss";

export class Slideshow extends React.Component {
  static propTypes = {
    /** Additional class names for the component */
    className: PropTypes.string,
    /** Id associated with component */
    id: PropTypes.string,
    /** Label associated with component */
    label: PropTypes.string,
    /** Array of Html to display */
    slides: PropTypes.arrayOf(
      PropTypes.shape({
        slide: PropTypes.node.isRequired,
        button: PropTypes.node,
      })
    ),
    /** Width of the slideshow */
    width: PropTypes.number,
    /** Height of the slideshow */
    height: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      activeSlideIndex: 0,
    };
  }

  onNextClick = () => {
    const { activeSlideIndex } = this.state;
    this.setState({
      activeSlideIndex: activeSlideIndex + 1,
    });
  };

  onPreviousClick = () => {
    const { activeSlideIndex } = this.state;
    this.setState({
      activeSlideIndex: activeSlideIndex - 1,
    });
  };

  onDotButtonClick = (event) => {
    const { activeSlideIndex } = this.state;
    if (activeSlideIndex !== Number(event.target.id)) {
      this.setState({ activeSlideIndex: Number(event.target.id) });
    }
  };

  onDotButtonKeydown = (event) => {
    if (event.key === "Enter") {
      this.onDotButtonClick(event);
    }
  };

  renderDotButtons = () => {
    const { slides } = this.props;
    const { activeSlideIndex } = this.state;

    return slides.map((slide, index) => {
      const dotButtonClass = classNames("dot__button", {
        active: activeSlideIndex === index,
      });

      if (slide.button === undefined) {
        return (
          <div
            key={index}
            id={index}
            label="dot button"
            role="button"
            tabIndex={0}
            onClick={this.onDotButtonClick}
            onKeyDown={this.onDotButtonKeydown}
            className={dotButtonClass}
          />
        );
      }
      return React.cloneElement(slide.button, {
        key: index,
        id: index,
        role: "button",
        tabIndex: 0,
        onClick: this.onDotButtonClick,
        onKeyDown: this.onDotButtonKeydown,
        className: dotButtonClass,
      });
    });
  };

  render() {
    const { className, height, id, label, slides, width } = this.props;
    const { activeSlideIndex } = this.state;

    const firstIndex = 0;
    const lastIndex = slides.length - 1;
    const slideshowClass = classNames("slideshow", className);

    return (
      <div className={slideshowClass} id={id} label={label}>
        <div className="slide__display">
          <div className="previous">
            {activeSlideIndex !== firstIndex && (
              <LeftChevronIcon
                fill="#555"
                className="previous__button"
                onClick={this.onPreviousClick}
              />
            )}
          </div>
          <div className="slide" style={{ width, height }}>
            {slides[activeSlideIndex].slide}
          </div>
          <div className="next">
            {activeSlideIndex !== lastIndex && (
              <RightChevronIcon
                fill="#555"
                className="next__button"
                onClick={this.onNextClick}
              />
            )}
          </div>
        </div>
        <div className="dot__buttons">{this.renderDotButtons()}</div>
      </div>
    );
  }
}
export default Slideshow;
